import React from 'react'

import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary'
import { EditorState } from 'lexical'
import ToolbarPlugin from '@/components/rich-text-editor/toolbar-plugin'
import useErrorHandler from '@/hooks/useErrorHandler'
import clsx from 'clsx'
import OnChangePlugin from './on-change-plugin'

export type RichTextEditorProps = {
	namespace?: string
	onChange?: (html: string) => void
	initialValue?: string
	placeholder?: string
	className?: string
}

export default function RichTextEditor({
	namespace = 'RichTextEditor',
	onChange,
	initialValue,
	placeholder = 'Write something...',
	className,
}: Readonly<RichTextEditorProps>) {
	const { handleError } = useErrorHandler()

	const handleLexicalError = (error: Error) => {
		handleError(error)
	}

	const initialConfig = {
		namespace,
		onError: handleLexicalError,
	}

	const handleChange = (editorState: EditorState, html: string) => {
		onChange?.(html)
	}

	return (
		<div className={clsx('p-2 border border-[#ddd]', className)}>
			<LexicalComposer initialConfig={initialConfig}>
				<div className="pb-2 border-b border-[#ddd]">
					<ToolbarPlugin />
				</div>
				<div className="h-64 relative overflow-scroll">
					<RichTextPlugin
						contentEditable={
							<ContentEditable
								className="p-1 h-full w-full outline-none bg-transparent relative z-10"
								aria-placeholder={placeholder}
								placeholder={
									<div className="absolute top-1 left-2 z-0 opacity-50">
										{placeholder}
									</div>
								}
							/>
						}
						ErrorBoundary={LexicalErrorBoundary}
					/>
				</div>
				<OnChangePlugin
					onChange={handleChange}
					initialValue={initialValue}
				/>
			</LexicalComposer>
		</div>
	)
}
